import axios from "axios";
import Links from "@/shared/constants/Links";

/**
 * Defense API hook — managing defenses (e.g. postgraduate defenses) and their
 * roster of qualified students.
 *
 * Access (enforced server-side; the UI mirrors it):
 *  - DEAN_SPGS: create / update details / roster / delete
 *  - HOD + DEAN_SPGS: read + update status
 */

const base = Links.defenses.base;

const Defenses = {
    /**
     * Create a defense request. HOD only.
     * @param {object} data DefenseRequest fields
     */
    create: async (data) => {
        return axios.post(base, data);
    },

    /**
     * List defense requests. HOD sees own department; DEAN_SPGS sees all.
     */
    all: async () => {
        return axios.get(base);
    },

    /**
     * Get a single defense request by id.
     * @param {number|string} id
     */
    get: async (id) => {
        return axios.get(`${base}/${id}`);
    },

    /**
     * Update a pending defense request. HOD only.
     * @param {number|string} id
     * @param {object} data DefenseRequest fields
     */
    update: async (id, data) => {
        return axios.put(`${base}/${id}`, data);
    },

    /**
     * Approve a defense request. DEAN_SPGS only.
     * @param {number|string} id
     */
    approve: async (id) => {
        return axios.patch(`${base}/${id}/approve`);
    },

    /**
     * Reject a defense request. DEAN_SPGS only.
     * @param {number|string} id
     * @param {string} reason
     */
    reject: async (id, reason) => {
        return axios.patch(`${base}/${id}/reject`, { reason });
    },

    /**
     * Delete a defense request. DEAN_SPGS only.
     * @param {number|string} id
     */
    delete: async (id) => {
        return axios.delete(`${base}/${id}`);
    },
};

export default Defenses;
